// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1767581362965
      var cssReload = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  